<app-view-title [isPrimaryColor]="true" Title="{{ 'Intellitrailer.Booking.Components.BookingSummary.Trailer' | translate : 'Trailer' }}: {{ booking?.RentalObject?.Alias ?? booking?.RentalObject?.Title }}"></app-view-title>

<view-content [centered]="true">
  @if (currentStep) {
  @if (isCheckingLockState) {
  <div class="nuwiel-checking-screen horizontal-vertical-center">
    <mat-progress-spinner diameter="75" mode="indeterminate" class="inverted-spinner"></mat-progress-spinner>
    <h2>{{ 'Intellitrailer.Rental.Nuwiel.Checking.Title1' | translate : 'Please wait while we verify the eTrailer status.' }}...</h2>
    <div class="step-check-status">
      <p class="check-status-text error">
        {{ 'Intellitrailer.Rental.Nuwiel.CompletePreviousStepsNote2' | translate : 'Please verify that you have completed all the steps before continuing.' }}
      </p>
    </div>
  </div>
  }
  @else {
  @switch (currentStep.id) {
  @case ('power-on') {
  <app-instruction-slider [secondaryColor]="true"
                          [slides]="powerOnSlides"
                          [unlockPin]="unlockPin"
                          (finalSlideReached)="onFinalSlideReached()">
  </app-instruction-slider>
  }

  @case ('parking-mode-off') {
  <app-instruction-slider [secondaryColor]="true"
                          [slides]="parkingModeOffSlides"
                          (finalSlideReached)="onFinalSlideReached()">
  </app-instruction-slider>
  }

  @case ('mode-select') {
  <app-information-screen [secondaryColor]="true"
                          title="{{ 'Intellitrailer.Rental.Nuwiel.Step.TravelModeSelect1.Title' | translate : 'Select trip mode' }}"
                          primaryContent="{{ 'Intellitrailer.Rental.Nuwiel.Step.TravelModeSelect1.Description' | translate : 'How are you moving today?' }}">
  </app-information-screen>

  <h2>{{ 'Intellitrailer.Rental.Nuwiel.Step.TravelMode1.TitleStep1' | translate : 'Cycling' }}</h2>
  <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-bike-mode.jpg" (click)="selectMode('BIKE')" />

  <h2>{{ 'Intellitrailer.Rental.Nuwiel.Step.TravelMode1.TitleStep2' | translate : 'Walking' }}</h2>
  <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-hand-mode.jpg" (click)="selectMode('HAND')" />

  <a class="link" (click)="previousStep()">
    {{ 'Intellitrailer.Rental.Nuwiel.cmdPreviousStep' | translate : 'Previous step' }}
  </a>
  }

  @case ('move-to-bike') {
  <app-instruction-slider [secondaryColor]="true"
                          [slides]="moveToBikeSlides"
                          (finalSlideReached)="onFinalSlideReached()">
  </app-instruction-slider>
  }

  @case ('hand-mode-instructions') {
  <app-instruction-slider [secondaryColor]="true"
                          [slides]="handCartModeSlides"
                          (finalSlideReached)="onFinalSlideReached()">
  </app-instruction-slider>
  }

  @case ('bike-pin') {
  <app-instruction-slider [secondaryColor]="true"
                          [slides]="bikeModeSlides"
                          (finalSlideReached)="onFinalSlideReached()">
  </app-instruction-slider>
  }

  @case ('parking-mode-select') {
  <app-information-screen [secondaryColor]="true"
                          title="{{ 'Intellitrailer.Rental.Nuwiel.Step.ReturnModeSelect.Title' | translate : 'How did you use the eTrailer?' }}">
  </app-information-screen>

  <h2>{{ 'Intellitrailer.Rental.Nuwiel.Mode1.Bike' | translate : 'Cycling' }}</h2>
  <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-bike-mode.jpg" (click)="selectParkingModeUsed('BIKE')" />

  <h2>{{ 'Intellitrailer.Rental.Nuwiel.Mode1.Hand' | translate : 'Walking' }}</h2>
  <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-hand-mode.jpg" (click)="selectParkingModeUsed('HAND')" />

  <a class="link" (click)="previousStep()">
    {{ 'Intellitrailer.Rental.Nuwiel.cmdPreviousStep' | translate : 'Previous step' }}
  </a>
  }

  @case ('parking-mode-on') {
  <app-instruction-slider [secondaryColor]="true"
                          [slides]="returnParkingModeSlides"
                          (finalSlideReached)="onFinalSlideReached()">
  </app-instruction-slider>
  }

  @case ('power-off') {
  <app-instruction-slider [secondaryColor]="true"
                          [slides]="powerOffSlides"
                          [unlockPin]="unlockPin"
                          (finalSlideReached)="onFinalSlideReached()">
  </app-instruction-slider>
  }
  }

  @if (hasCheckFailed) {
  <div class="step-check-status">
    <p class="check-status-text error">
      {{ 'Intellitrailer.Rental.Nuwiel.Checking.TimeoutDescription1' | translate : 'Unable to verify the trailer status. Please try again.' }}
    </p>
  </div>
  }
  }
  }
</view-content>

<view-actions>
  @if (currentStep && !isCheckingLockState && !hasCheckFailed && currentStep.id !== 'mode-select' && currentStep.id !== 'parking-mode-select') {
  <div class="row">
    @if (canShowPreviousButton()) {
    <div class="col-6">
      <button mat-raised-button color="accent" class="mw-160" (click)="previousStep()">
        {{ 'Intellitrailer.Rental.Nuwiel.cmdPrevious' | translate : 'Previous' }}
      </button>
    </div>
    }

    <div [class.col-6]="canShowPreviousButton()" [class.col-12]="!canShowPreviousButton()" class="next-action-container">
      <!--<button mat-raised-button color="accent" class="mw-160" [disabled]="!canContinue()" (click)="next()">-->
      <button mat-raised-button color="accent" class="mw-160" (click)="next()">
        {{ 'Intellitrailer.Rental.Nuwiel.cmdNext' | translate : 'Next' }}
      </button>

      <!--@if (!canContinue()) {
      <div class="complete-steps-popup">
        {{ 'Intellitrailer.Rental.Nuwiel1.CompleteStepsMessage' | translate : 'Please complete all the steps to continue.' }}
      </div>
      }-->
    </div>
  </div>
  }

  @if (currentStep && !isCheckingLockState && !hasCheckFailed && currentStep.id === 'mode-select') {
  <div class="row">
    <div class="col-6">
      <button type="button" mat-raised-button color="accent" class="mw-160" (click)="selectMode('BIKE')">
        {{ 'Intellitrailer.Rental.Nuwiel.Mode1.Bike' | translate : 'Cycling' }}
      </button>
    </div>

    <div class="col-6">
      <button type="button" mat-raised-button color="accent" class="mw-160" (click)="selectMode('HAND')">
        {{ 'Intellitrailer.Rental.Nuwiel.Mode1.Hand' | translate : 'Walking' }}
      </button>
    </div>
  </div>
  }

  @if (currentStep && !isCheckingLockState && !hasCheckFailed && currentStep.id === 'parking-mode-select') {
  <div class="row">
    <div class="col-6">
      <button type="button" mat-raised-button color="accent" class="mw-160" (click)="selectParkingModeUsed('BIKE')">
        {{ 'Intellitrailer.Rental.Nuwiel.Mode1.Bike' | translate : 'Cycling' }}
      </button>
    </div>

    <div class="col-6">
      <button type="button" mat-raised-button color="accent" class="mw-160" (click)="selectParkingModeUsed('HAND')">
        {{ 'Intellitrailer.Rental.Nuwiel.Mode1.Hand' | translate : 'Walking' }}
      </button>
    </div>
  </div>
  }

  @if (currentStep && isCheckingLockState && currentStep.requiresCheck) {
  <button mat-raised-button color="accent" (click)="continueAfterCheck()">
    {{ ('Intellitrailer.Rental.Nuwiel.ManualContinue1.' + currentStep.id) | translate : getManualContinueText() }}
  </button>
  }

  @if (currentStep && hasCheckFailed && currentStep.requiresCheck) {
  <button mat-raised-button color="accent" (click)="retry()">
    {{ 'Intellitrailer.Rental.Nuwiel.Retry' | translate : 'Retry' }}
  </button>
  }
</view-actions>
